import { useCallback } from "react";
import { useDefaultDraft } from "./useDefaultDraft";

const sourcesMatch = (first: { id: number }, second: { id: number }) =>
  first.id === second.id;

export const useDefaultSetDraft = <Set extends { id: number }, Override>({
  defaultSet,
  emptyOverrides,
  hasChanged,
}: {
  defaultSet: Set;
  emptyOverrides: Override[];
  hasChanged: (source: Set, override: Override) => boolean;
}) => {
  const createDraft = useCallback(() => emptyOverrides, [emptyOverrides]);
  const normaliseDraft = useCallback(
    (source: Set, proposed: Override[]) => {
      const changed = proposed.filter((override) =>
        hasChanged(source, override)
      );
      return changed.length === 0 ? null : changed;
    },
    [hasChanged]
  );
  const { draft, setDraft, ...lifecycle } = useDefaultDraft({
    defaultSource: defaultSet,
    createDraft,
    normaliseDraft,
    sourcesMatch,
  });
  return { ...lifecycle, overrides: draft, setOverrides: setDraft };
};
